export enum ErrorExtensionsCode {
  AUTH_NOT_AUTHORIZED = 'AUTH_NOT_AUTHORIZED',
}
